import AcademicTerm from "./AcademicTerm";
import AcademicTermRange from "./AcademicTermRange";
import Address from "./Address";

class Campus {
    id: number;
    name: string;
    address: Address;
    terms: AcademicTerm[];

    constructor(data?: Partial<Campus>) {
        Object.assign(this, data);

        this.terms = this.terms?.map(t => new AcademicTerm(t)) || [];
        this.address = this.address ? new Address(this.address) : null;
    }

    hasRangeId(id: number) {
        return this.terms.some(t =>
            t.ranges.some(
                r => r.id === id || r.children.some(c => c.id === id),
            ),
        );
    }

    replaceRange(updated: AcademicTermRange) {
        this.terms.forEach(t => t.replaceRange(updated));
    }

    removeTermsByRangeId(id: number) {
        this.terms = this.terms.filter(t => t.id !== id);
    }

    hasError() {
        return this.terms.some(t => t.hasError());
    }
}

export default Campus;
